import React from "react";
import { ReactComponent as Phone } from "../../assets/icons/phone.svg";
import { ReactComponent as Email } from "../../assets/icons/email.svg";
import { ReactComponent as Location } from "../../assets/icons/location.svg";
import { Icon } from "@iconify/react";

import classes from "./Contact.module.css";
import { useTranslation } from "react-i18next";

export const Contacts = () => {
    const { t } = useTranslation();

    const socialLinks = [
        {
            icon: "ic:baseline-telegram",
            link: "https://t.me/renessansedu_uz",
            color: "#0088cc",
            label: "Telegram"
        },
        {
            icon: "mdi:instagram",
            link: "https://www.instagram.com/renessans.edu.uz/",
            color: "#e4405f",
            label: "Instagram"
        },
        {
            icon: "ri:facebook-fill",
            link: "https://www.facebook.com/profile.php?id=61557702814655",
            color: "#1877f2",
            label: "Facebook"
        },
        {
            icon: "mdi:linkedin",
            link: "https://www.linkedin.com/company/renaissance-educational-university/",
            color: "#0a66c2",
            label: "LinkedIn"
        },
        {
            icon: "mdi:youtube",
            link: "https://www.youtube.com/@renessansuniversity",
            color: "#ff0000",
            label: "YouTube"
        }
    ];

    return (
        <div className={classes["main-container"]}>
            <div data-aos="fade-down" className={classes["section"]}>
                {/* phone */}
                <div className={classes["box"]}>
                    <div className={classes["circle"]}>
                        <Phone className={classes["icon"]} />
                    </div>
                    <div className={classes["flex"]}>
                        <p className={classes["title"]}>{t("contactPhoneNum")}</p>
                        <a target="_blank" href="tel: +998555067007">
                            <p className={classes["text"]}>(55) 506 70 07</p>
                        </a>
                    </div>
                </div>
                {/* email */}
                <div className={classes["box"]}>
                    <div className={classes["circle"]}>
                        <Email className={classes["icon"]} />
                    </div>
                    <div className={classes["flex"]}>
                        <p className={classes["title"]}>{t("emailAdress")}</p>
                        <a target="_blank" href="mailto: info@renessans-edu.uz">
                            <p className={classes["text"]}>info@renessans-edu.uz</p>
                        </a>
                    </div>
                </div>
                {/* location */}
                <div className={classes["box"]}>
                    <div className={classes["circle"]}>
                        <Location className={classes["icon"]} />
                    </div>
                    <div className={classes["flex"]}>
                        <p className={classes["title"]}>{t(`locationContact`)}</p>
                        <div className={classes["campusList"]}>
                            <p className={classes["campusText"]}>
                                <strong>{t("campus_shayxontohur")}:</strong><br />
                                {t("mapBr1")}, {t("mapBr")}
                            </p>
                            <p className={classes["campusText"]}>
                                <strong>{t("campus_beruniy")}:</strong><br />
                                Talabalar shaharchasi, Beruniy 2-uy
                            </p>
                            <p className={classes["campusText"]}>
                                <strong>{t("campus_yunusobod")}:</strong><br />
                                Bog'ishamol ko'chasi, 220-uy
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Social Media Section */}
            <div data-aos="fade-up" className={classes["socialSection"]}>
                <h2 className={classes["socialHeader"]}>{t("ourSocialMedias")}</h2>
                <div className={classes["socialGrid"]}>
                    {socialLinks.map((item, index) => (
                        <a
                            key={index}
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes["socialCard"]}
                            style={{ "--brand-color": item.color }}
                        >
                            <div className={classes["socialCircle"]}>
                                <Icon icon={item.icon} className={classes["socialIcon"]} />
                            </div>
                            <span className={classes["socialLabel"]}>{item.label}</span>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};
